import { Tabs } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";

interface PatientDetailTabsProps {
  selectedTab: number;
  onTabChange: (selectedTabIndex: number) => void;
}

function PatientDetailTabs({
  selectedTab,
  onTabChange,
}: PatientDetailTabsProps) {
  const { t } = useTranslation();

  const tabs = [
    { id: "overview", content: t("patientDetails.tabs.all") },
    { id: "properties", content: t("patientDetails.tabs.properties") },
    { id: "treatments", content: t("patientDetails.tabs.treatments") },
    { id: "documents", content: t("patientDetails.tabs.documents") },
    { id: "images", content: t("patientDetails.tabs.images") },
    { id: "tasks", content: t("patientDetails.tabs.tasks") },
    { id: "appointments", content: t("patientDetails.tabs.appointments") },
  ];

  return <Tabs tabs={tabs} selected={selectedTab} onSelect={onTabChange} />;
}

export default PatientDetailTabs;
